import { useEffect } from 'react';

/**
 * GoogleAnalytics — loads GA4 only when REACT_APP_GA_MEASUREMENT_ID is set.
 *
 * To activate:
 *   1. Create a GA4 property at https://analytics.google.com
 *   2. Copy the Measurement ID (looks like G-XXXXXXXXXX)
 *   3. Add REACT_APP_GA_MEASUREMENT_ID="G-XXXXXXXXXX" to /app/frontend/.env
 *   4. Redeploy
 *
 * Until then, this component is a silent no-op (no requests, no bundle bloat).
 */
const GoogleAnalytics = () => {
  useEffect(() => {
    const gaId = process.env.REACT_APP_GA_MEASUREMENT_ID;
    if (!gaId || typeof window === 'undefined' || window.__ga_loaded__) return;
    window.__ga_loaded__ = true;

    // Inject gtag library
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(gaId)}`;
    document.head.appendChild(script);

    // Init dataLayer + gtag
    window.dataLayer = window.dataLayer || [];
    function gtag() { window.dataLayer.push(arguments); }
    window.gtag = gtag;
    gtag('js', new Date());
    gtag('config', gaId, { send_page_view: true, anonymize_ip: true });
  }, []);

  return null;
};

export default GoogleAnalytics;
